import { NonLinearStepper } from 'components/OrderDetails/Tabs/OrderProgressTab/NonLinearStepper';
import { LinearStepper } from 'components/OrderDetails/Tabs/OrderProgressTab/LinearStepper';

export const ProgressStepper = ({ stepper, isLoading = false }) =>
  stepper.isNonLinear ? (
    <NonLinearStepper stepper={stepper} isLoading={isLoading} />
  ) : (
    <LinearStepper stepper={stepper} isLoading={isLoading} />
  );
